import { ComponentChildren } from 'preact'

interface StatusBadgeProps {
  variant?: string
  children: ComponentChildren
}

const StatusBadge = ({ variant = 'default', ...props }: StatusBadgeProps) => (
  <div className={`status-badge status-badge--${variant}`} {...props} />
)

export default StatusBadge
